import { buildArticle } from "./_articleBuilder";

export default buildArticle({
  slug: "how-long-does-a-tms-appointment-take",
  title: "How Long Does a TMS Appointment Take?",
  description:
    "TMS appointment length depends on the protocol. Traditional TMS sessions are short; SAINT® involves a full day. Learn what to expect from each.",
  keywords:
    "TMS appointment length, how long TMS takes, TMS session duration, SAINT appointment time",
  badge: "Educational Article",
  heroTitle: "How Long Does a TMS Appointment Take?",
  heroSubtitle:
    "The length of a TMS appointment depends on which protocol you're receiving. Traditional TMS and accelerated protocols like SAINT® have very different daily time commitments.",
  sections: [
    {
      heading: "Traditional TMS",
      body: "A traditional TMS session is relatively short — typically under an hour, including setup and the stimulation itself. You can often return to your normal activities afterward, including driving.",
    },
    {
      heading: "SAINT® and Accelerated TMS",
      body: "SAINT® delivers multiple sessions per day over five consecutive days, with sessions spaced roughly an hour apart. This means you're on site for most of the day during the treatment week — a very different time commitment than traditional TMS.",
    },
    {
      heading: "SPRAVATO®",
      body: "If you're comparing with SPRAVATO®, each visit runs about two to three hours, including the required monitoring period after each dose.",
    },
    {
      heading: "Planning Your Time",
      body: "Understanding the daily time commitment helps you plan. Traditional TMS fits into a daily routine more easily; accelerated protocols require a dedicated week. We can discuss scheduling during your consultation.",
      callout: true,
    },
  ],
  faq: [
    {
      question: "Can I go to work after a TMS session?",
      answer:
        "For traditional TMS, most people can return to normal activities, including work, after a session. Accelerated protocols like SAINT® involve a full day on site, so work during the treatment week may not be practical.",
    },
    {
      question: "How long is the entire TMS course?",
      answer:
        "Traditional TMS spans several weeks of daily sessions. SAINT® compresses the course into five consecutive days. The total treatment time depends on the protocol.",
    },
  ],
  related: [
    {
      title: "How Many TMS Sessions Are Needed?",
      href: "/how-many-tms-sessions",
    },
    { title: "What TMS Feels Like", href: "/what-tms-feels-like" },
    {
      title: "SAINT® vs. Traditional TMS",
      href: "/learn/saint-vs-traditional-tms",
    },
  ],
  finalCtaText:
    "Questions about scheduling are practical and important. Speak with our team about what to expect.",
});
